<p-dialog [(visible)]="display" [position]="'right'" [draggable]="false" [style]="{width: widthVW}">
    <p-header>
        <div class="content">
            <p><img class="icon" src="../../../../assets/images/Circle-Check.png"/></p>
            <p>{{title}}</p>
        </div>
    </p-header>
</p-dialog>